module.exports = __webpack_public_path__ + "img/kong-color.e3ed41ac.svg";